export const InitialState = {
    token : '',
    tableDetail : {},
    tables : [],
    tableCategories : [],
    restaurants : [],
    restaurant : {}
}